var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("people-nav", {
        attrs: { "viewing-profile": _vm.viewingProfile },
        on: {
          updatedSearchTerm: _vm.handleSearch,
          backToMainPeoplePage: _vm.handleBack
        }
      }),
      _vm._v(" "),
      _vm.viewingProfile
        ? _c("person-selector", {
            attrs: { people: _vm.filteredPeople },
            on: { selectPerson: _vm.selectPerson }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "person-content" }, [
        _vm.viewingProfile
          ? _c("div", { staticClass: "person-display" }, [_c("person-page")], 1)
          : _vm._e(),
        _vm._v(" "),
        !_vm.viewingProfile
          ? _c(
              "div",
              [
                _c("people-filters", {
                  on: {
                    changeFilter: _vm.handleChangeFilter,
                    showInactive: _vm.handleShowInactive
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "people-cards" },
                  _vm._l(_vm.filteredPeople, function(p) {
                    return _c(
                      "div",
                      {
                        key: p.fName + p.lName,
                        staticClass: "person-card",
                        on: {
                          click: function($event) {
                            return _vm.selectPerson(p)
                          }
                        }
                      },
                      [
                        _c("v-card", { attrs: { color: "white" } }, [
                          _c("div", { staticClass: "person-image-holder" }, [
                            _c("img", {
                              staticClass: "person-image",
                              attrs: {
                                src:
                                  "https://cdn.vuetifyjs.com/images/cards/road.jpg"
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "person-card-content person-name" },
                            [_vm._v(_vm._s(p.fName + " " + p.lName))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "person-card-content person-job" },
                            [_vm._v(_vm._s(p.group))]
                          )
                        ])
                      ],
                      1
                    )
                  }),
                  0
                )
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71fef2af", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71fef2af","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/People/People.vue
// module id = UZoC
// module chunks = 1